import React, { FC, useEffect } from "react";
import InputField from "app/components/common/inputs/InputField";
import FormGroup from "app/components/common/inputs/FormGroup";
import SelectField from "app/components/common/inputs/SelectField";
import IncomeInputs from "app/components/common/inputs/IncomeInputs";
import {
  CurrentemploymentOptions,
  frequencyOptions,
} from "app/utils/staticValues";

interface EmploymentAndIncomeDetailsProps {
  control: any;
  errors: any;
  fields: { id: string }[];
  employmentTypeName: string;
  employerName: string;
  incomeName: string;
  employmenttypeValue?: string;
}

const EmploymentDynamicForm: FC<EmploymentAndIncomeDetailsProps> = ({
  control,
  errors,
  fields,
  employmentTypeName,
  employerName,
  incomeName,
  employmenttypeValue,
}) => {
  const getErrorMessage = (fieldName: string) => {
    const fieldNames = fieldName.split(".");
    return fieldNames.reduce((acc, key) => acc && acc[key], errors);
  };
  const isEmployerRequired = employmenttypeValue === "unemployed_or_retired";
  const isNotRequired =
    employmenttypeValue === "contractor" ||
    employmenttypeValue === "self-employed" ||
    employmenttypeValue === "unemployed_or_retired";

  return (
    <>
      <FormGroup>
        <SelectField
          label="Employment type"
          name={employmentTypeName}
          control={control}
          options={CurrentemploymentOptions}
          placeholder="Please select employment type"
          error={getErrorMessage(employmentTypeName)?.message as string}
          required={true}
          className="flex-1"
        />
        <InputField
          label="Employer name"
          name={employerName}
          control={control}
          type="text"
          required={!isNotRequired}
          placeholder="James Willson"
          error={getErrorMessage(employerName)?.message as string}
          disabled={isEmployerRequired}
          className="flex-1"
          rules={{
            pattern: {
              value: /^[A-Za-z\s]+$/,
              message: "Only alphabets are allowed",
            },
          }}
        />
      </FormGroup>
      {fields.map((field, index) => {
        const basePath = `${incomeName}.${index}`;
        return (
          <>
            <React.Fragment key={field.id}>
              <FormGroup className="relative">
                <IncomeInputs
                  label={index === 0 ? "Income" : "Other income"}
                  tooltip={
                    index === 0
                      ? ""
                      : "Money you earn from things like renting out property, investments, or other sources besides your job"
                  }
                  name={`${basePath}.amount`}
                  control={control}
                  type="number"
                  required={index === 0 ? true : false}
                  placeholder="$200,000"
                  error={
                    getErrorMessage(`${basePath}.amount`)?.message as string
                  }
                  className="flex-1"
                  // rules={{
                  //   ...(isEmployerRequired
                  //     ? {}
                  //     : index === 0
                  //     ? {
                  //         min: {
                  //           value: 1,
                  //           message: "Value must be greater than 0",
                  //         },
                  //       }
                  //     : {
                  //         required: "Amount is required",
                  //       }),
                  // }}
                  selectlabel="frequency"
                  selectname={`${basePath}.frequency`}
                  selectoptions={frequencyOptions}
                  selectplaceholder="Monthly"
                  selectrequired={true}
                  selecterror={
                    getErrorMessage(`${basePath}.frequency`)?.message as string
                  }
                  disabled={isEmployerRequired}
                />
              </FormGroup>
            </React.Fragment>
          </>
        );
      })}
    </>
  );
};

export default EmploymentDynamicForm;
